import clsx from "clsx";
import Image from "next/image";
import bgSpeedCMS from "/public/bg-SpeedCMS.webp";
import { LogoSpeedCms } from "@/components/molecules/logos/LogoSpeedCms";

export const SpeedCmsCover = ({ className }) => {
  return (
    <>
      <div
        className={clsx(
          className,
          "relative mx-auto box-border flex aspect-3.5/1 items-center justify-center border border-solid border-bdc-base"
        )}
      >
        <div className="flex items-center justify-center">
          <h2 className="relative z-10">
            <LogoSpeedCms className="h-[50px] w-[200px] md:h-[80px] md:w-[320px]" />
          </h2>
        </div>
        <div className="z-0">
          <Image
            src={bgSpeedCMS}
            alt="SpeedCMS スピードシーエムエス"
            quality={80}
            layout="fill"
            objectFit="cover"
          />
        </div>
      </div>
    </>
  );
};
